import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ElementProperty } from "../../../models/base-info/element-property.model";
import { EffectBase } from "../../../models/enums/effect-base";
import { EffectOnEffectWrk } from "../../../models/enums/effect-on-effect-wrk";
import { EffectStatuteKind } from "../../../models/enums/effect-statute-kind";
import { EffectWorkKind } from "../../../models/enums/effect-work-kind";
import { ElementGroup } from "../../../models/enums/element-group";
import { ElementKind } from "../../../models/enums/element-kind";
import { ElemntshowKind } from "../../../models/enums/elemntshow-kind";
import { RoundKind } from "../../../models/enums/round-kind";

@Component({
  selector: "ngx-element-property-form",
  templateUrl: "./element-property-form.component.html",
  styleUrls: ["./element-property-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementPropertyFormComponent extends BaseFormComponent<ElementProperty> {
  @Input() _columns: form_control[] = [];
  public apiName: string = "Element";
  public label: string = "تعریف خصوصیت عامل";
  @Input() ElementGroupCode: number;
  @Input() ElementKindCode: number;

  constructor(protected selectorService: SelectorService, private lookupservice: LookupService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.columns = this._columns;
    this.orignalColumns = this._columns;

    if (!this.currentrow) this.newRow();
    else {
      this.model = Object.assign({}, this.currentrow as ElementProperty);
      this.isNewRow = this.model === undefined || this.model.State === RowState.New;
      this.setdefault();
      this.setFormGroup(this.model);
    }
  }
  onvalueChangeWithName($event) {
    if ($event && $event?.name === "ProportionalWorkEffect") {
      this.model.ProportionalWorkEffect = $event.value;
      if (this.formGroup && this.formGroup.get("EffectBaseId")) {
        if ($event.value) {
          this.formGroup.get("EffectBaseId").enable();
          this.formGroup.get("EffectBaseId").setValue(13200);
        } else this.formGroup.get("EffectBaseId").disable();
      }
    }

    if ($event && $event?.name === "EffectBaseId") {
      this.model.EffectBaseCode = $event.value;
    }
    this.setdefault();
    this.cd.markForCheck();
  }
  addControl() {
    this.setDefaultValues();
  }
  onChange($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Lookup") && $event.KeyName === "EffectBaseId") {
      this.setValue("EffectBaseCode", $event.data.Code);
      this.setValue("EffectBaseTitle", $event.data.Title);
      this.model.EffectBaseTitle = $event.data.Title;
      this.model.EffectBaseCode = $event.data.Code;
      this.setdefault();
      this.cd.markForCheck();
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("EmploymentKind/ReadLookUp")) {
      this.setValue("EmploymentKindCode", $event.data.Code);
      this.setValue("EmploymentKindTitle", $event.data.Title);
      this.model.EmploymentKindTitle = $event.data.Title;
      this.model.EmploymentKindCode = $event.data.Code;
      this.setdefault();
      this.cd.markForCheck();
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Element/ReadLookUp") && $event.KeyName === "CalcBaseId") {
      this.setValue("CalcBaseTitle", $event.data.Title);
      this.model.CalcBaseTitle = $event.data.Title;
      this.setdefault();
      this.cd.markForCheck();
    }
    if (
      $event.apiName &&
      $event.data &&
      $event.data.Id &&
      $event.apiName.includes("Element/ReadLookUp") &&
      $event.KeyName === "ProportionalwithElementId"
    ) {
      this.setValue("ProportionalwithElementTitle", $event.data.Title);
      this.model.ProportionalwithElementTitle = $event.data.Title;
      this.setdefault();
      this.cd.markForCheck();
    }
  }
  setDefaultValues() {
    this.columns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) {
        if (this.model[x.name] == undefined) {
          this.model[x.name] = false;
          this.setValue(x.name, this.model[x.name]);
        }
      }
    });
  }
  setdefault() {
    if (!this.model.IssueYear) this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    if (!this.model.IssueMonth) this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;

    if (!this.model.EffectYear) this.model.EffectYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    if (!this.model.EffectMonth) this.model.EffectMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;

    if (this.isNewRow && this.model.Active === undefined) this.model.Active = true;
    if (this.isNewRow && !this.model.EffectWorkKindId) {
      this.lookupservice
        .getLookupbyCode("HRM", "EffectWorkKind", EffectWorkKind.Work)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.EffectWorkKindId = x.Id;
          this.model.EffectWorkKindTitle = x.Title;
          this.setValue("EffectWorkKindId", x.Id);
          this.setValue("EffectWorkKindTitle", x.Title);
        });
    }
    if (this.isNewRow && !this.model.ElemntshowKindId) {
      this.lookupservice
        .getLookupbyCode("HRM", "ElemntshowKind", ElemntshowKind.HHMM)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.ElemntshowKindId = x.Id;
          this.model.ElemntshowKindTitle = x.Title;
          this.setValue("ElemntshowKindId", x.Id);
          this.setValue("ElemntshowKindTitle", x.Title);
        });
    }
    if (this.isNewRow && !this.model.EffectOnEffectWrkId) {
      this.lookupservice
        .getLookupbyCode("HRM", "EffectOnEffectWrk", EffectOnEffectWrk.Neutral)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.EffectOnEffectWrkId = x.Id;
          this.model.EffectOnEffectWrkTitle = x.Title;
          this.setValue("EffectOnEffectWrkId", x.Id);
          this.setValue("EffectOnEffectWrkTitle", x.Title);
        });
    }
    if (this.isNewRow && !this.model.EffectStatuteKindId) {
      this.lookupservice
        .getLookupbyCode("HRM", "EffectStatuteKind", EffectStatuteKind.Monthly)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.EffectStatuteKindId = x.Id;
          this.model.EffectStatuteKindTitle = x.Title;
          this.setValue("EffectStatuteKindId", x.Id);
          this.setValue("EffectStatuteKindTitle", x.Title);
        });
    }
    if (this.isNewRow && !this.model.RoundKindId) {
      this.lookupservice
        .getLookupbyCode("HRM", "RoundKind", RoundKind.Normal)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.RoundKindId = x.Id;
          this.model.RoundKindTitle = x.Title;
          this.setValue("RoundKindId", x.Id);
          this.setValue("RoundKindTitle", x.Title);
        });
    }
    this.columns.forEach((x) => {
      if (
        x.name === "ProportionalwithElementId" ||
        x.name === "EffectStatuteKindId" ||
        x.name === "RoundLength" ||
        x.name === "RoundKindId" ||
        x.name === "ProportionalwithElementId" ||
        x.name === "CalcBaseId" ||
        x.name === "Coefficien" ||
        x.name === "ProportionalWorkEffect" ||
        x.name === "EffectBaseAmount" ||
        x.name === "EffectBaseId"
      )
        x.formVisible = this.ElementGroupCode !== ElementGroup.Work;

      if (
        x.name === "Insurable" ||
        x.name === "TaxableContinues" ||
        x.name === "HasBackpay" ||
        x.name === "Adjustment" ||
        x.name === "TaxableUnContinues"
      )
        x.formVisible = this.ElementGroupCode !== ElementGroup.Work && this.ElementGroupCode !== ElementGroup.Loan;

      if (x.name === "EffectBaseId" && this.ElementGroupCode !== ElementGroup.Work) {
        x.disabled = !this.model.ProportionalWorkEffect;
        x.required = this.model.ProportionalWorkEffect;
        if (this.formGroup && this.formGroup.get("EffectBaseId")) {
          if (x.disabled) this.formGroup.get("EffectBaseId").disable();
          else this.formGroup.get("EffectBaseId").enable();
        }
      }

      if (x.name === "EffectWorkKindId" || x.name === "EffectOnEffectWrkId" || x.name === "ElemntshowKindId" || x.name === "DayBase") {
        if (x.name === "ElemntshowKindId" || x.name === "DayBase")
          x.formVisible = this.ElementGroupCode === ElementGroup.Work || this.ElementKindCode === ElementKind.LeaveRemain;
        else x.formVisible = this.ElementGroupCode === ElementGroup.Work;
      }
      if (x.name === "EffectStatuteKindId") {
        x.formVisible = this.ElementGroupCode !== ElementGroup.Work && this.ElementKindCode === ElementKind.EmploymentOrder;
      }
      if (x.name === "EffectBaseAmount") {
        x.disabled = this.model.EffectBaseCode !== EffectBase.FixedWork && this.formGroup?.controls["EffectBaseCode"]?.value !== EffectBase.FixedWork;
        if (this.formGroup && this.formGroup.get("EffectBaseAmount")) {
          if (!x.disabled) {
            this.formGroup.get("EffectBaseAmount").setValue(13200);
            this.formGroup.get("EffectBaseAmount").enable();
          } else this.formGroup.get("EffectBaseAmount").disable();
        }
        x.required = !x.disabled;
      }
      if (x.name === "EffectMonth") {
        if (this.ElementGroupCode === ElementGroup.Work || this.ElementGroupCode === ElementGroup.Loan) x.isFloat = undefined;
        else x.isFloat = 1;
      }
      if (x.name === "MaxAmount") {
        if (this.ElementGroupCode === ElementGroup.Loan) x.isFloat = undefined;
        else x.isFloat = 1;
      }
      if (x.name === "CalcBaseId") {
        if (this.ElementGroupCode === ElementGroup.Loan) x.isFloat = 1;
        else x.isFloat = undefined;
      }
    });
  }

  async save() {
    this.result = this.getDataFromFormGroup();
    this.closeModal();
  }
}
